module.exports = __webpack_public_path__ + "static/media/no-avatar.fd75d9c9.svg";